/* ============================================================
   BLOGPOST EDITORIAL — File: assets/blogpost-editorial.js
   ============================================================ */
(function () {
  function init(section) {
    const article = section.querySelector('[data-bpx-article]');
    const bar = section.querySelector('[data-bpx-progress]');
    const tocItems = Array.from(section.querySelectorAll('[data-bpx-toc-item]'));
    const targets = tocItems
      .map(li => document.getElementById(li.getAttribute('data-bpx-toc-item')))
      .filter(Boolean);

    function onScroll() {
      // progress
      if (bar && article) {
        const top = article.offsetTop;
        const height = article.offsetHeight - window.innerHeight;
        const scrolled = Math.max(0, window.scrollY - top);
        bar.style.width = Math.min(1, scrolled / Math.max(1, height)) * 100 + '%';
      }
      // active toc
      if (targets.length) {
        const y = window.scrollY + 200;
        let current = targets[0];
        targets.forEach(t => { if (t.offsetTop <= y) current = t; });
        tocItems.forEach(li => {
          li.classList.toggle('is-active', li.getAttribute('data-bpx-toc-item') === current.id);
        });
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    // checklist
    section.querySelectorAll('[data-bpx-check]').forEach(function (box) {
      const items = Array.from(box.querySelectorAll('[data-bpx-check-item]'));
      const count = box.querySelector('[data-bpx-check-count]');
      items.forEach(function (it) {
        it.addEventListener('click', function () {
          it.classList.toggle('is-done');
          if (count) {
            const done = items.filter(function (x) { return x.classList.contains('is-done'); }).length;
            count.textContent = done + ' / ' + items.length;
          }
        });
      });
    });

    // faq
    section.querySelectorAll('.bpx-faq-q').forEach(function (q) {
      q.addEventListener('click', function () {
        q.parentElement.classList.toggle('open');
      });
    });
  }

  function initAll() { document.querySelectorAll('.bpx').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', (e) => {
    const s = e.target.querySelector('.bpx'); if (s) init(s);
  });
})();
